import React from "react";
import { useSideQueues } from "./hooks/useSideQueues";

import "./side-queues.styles.css";
import SearchInput from "../../../SearchInput";
import QueueItemMonitoring from "../../../QueueItemMonitoring/QueueItemMonitoring";
import { AutoSizer, List } from "react-virtualized";
import OrderFilter from "../../../OrderFilter/OrderFilter";

const SideQueues = ({
  arrayChats,
  selectedChat,
  setSelectedChat,
  setMonitorMessage,
  changeDisplayTransfer,
  ViewAnotations,
  setOpenSearch,
  hasVoice,
  onSelectCall,
}) => {
  const {
    filteredRegularChats,
    filteredSatndbyChats,
    tabs,
    tabSelected,
    messages,
    tabFilterRegularChatSelected,
    tabFilterStandbyChatSelected,
    numberOfStandbyChatsWithUnreadedMessages,
    numberOfRegularChatsWithUnreadedMessages,
    filterOrderRegularChat,
    filterOrderStandbyChat,
    textToFilterRegularChats,
    textToFilterStandbyChats,
    handleChangeTab,
    onSearch,
    changeTabFilterRegularChat,
    changeTabFilterStandbyChat,
    handleChangeOrderFilterRegularChats,
    handleChangeOrderFilterStandbyChats,
    onEndCall,
    onTransferCall,
    onAnnotationCall,
    onSearchInCall,
  } = useSideQueues(
    arrayChats,
    setSelectedChat,
    setMonitorMessage,
    changeDisplayTransfer,
    ViewAnotations,
    setOpenSearch,
    hasVoice
  );

  // const renderCorrectOrderFilter = () => {
  //   switch (tabSelected) {
  //     case "standByChatsTab":
  //       return (
  //         <LightTooltip
  //           title={
  //             <ul className="menu-chats">
  //               <li
  //                 className={`menu-chats__option order-filter ${
  //                   filterOrderStandbyChat === "message" ? "active" : ""
  //                 }`}
  //                 onClick={(event) => {
  //                   handleChangeOrderFilterStandbyChats("message");
  //                 }}
  //               >
  //                 <MessageNotif />
  //                 <Typography.H5 weight={500} color={"gray-180"}>
  //                   Conversas recentes
  //                 </Typography.H5>
  //               </li>
  //               <li
  //                 className={`menu-chats__option order-filter ${
  //                   filterOrderStandbyChat === "order" ? "active" : ""
  //                 }`}
  //                 onClick={() => {
  //                   handleChangeOrderFilterStandbyChats("order");
  //                 }}
  //               >
  //                 <Message2 />
  //                 <Typography.H5 weight={500} color={"gray-180"}>
  //                   Ordem de chegada
  //                 </Typography.H5>
  //               </li>
  //             </ul>
  //           }
  //           placement="bottom"
  //           open={openOrderFilterRegularChats}
  //           onClose={() => handleCloseOrderFilterRegularChat()}
  //         >
  //           <div
  //             className={`action tippy-context-menu${
  //               openOrderFilterRegularChats ? " active" : ""
  //             }`}
  //             onClick={(e) => {
  //               e.preventDefault();
  //               handleOpenOrderFilterRegularChat();
  //             }}
  //           >
  //             <Setting color="#455CC7" variant="outline" />
  //           </div>
  //         </LightTooltip>
  //       );
  //     case "regularChatTab":
  //       return (
  //         <LightTooltip
  //           title={
  //             <ul className="menu-chats">
  //               <li
  //                 className={`menu-chats__option order-filter ${
  //                   filterOrderRegularChat === "message" ? "active" : ""
  //                 }`}
  //                 onClick={(event) => {
  //                   handleChangeOrderFilterRegularChats("message");
  //                 }}
  //               >
  //                 <MessageNotif />
  //                 <Typography.H5 weight={500} color={"gray-180"}>
  //                   Conversas recentes
  //                 </Typography.H5>
  //               </li>
  //               <li
  //                 className={`menu-chats__option order-filter ${
  //                   filterOrderRegularChat === "order" ? "active" : ""
  //                 }`}
  //                 onClick={() => {
  //                   handleChangeOrderFilterRegularChats("order");
  //                 }}
  //               >
  //                 <Message2 />
  //                 <Typography.H5 weight={500} color={"gray-180"}>
  //                   Ordem de chegada
  //                 </Typography.H5>
  //               </li>
  //             </ul>
  //           }
  //           placement="bottom"
  //           open={openOrderFilterRegularChats}
  //           onClose={() => handleCloseOrderFilterRegularChat()}
  //         >
  //           <div
  //             className={`action tippy-context-menu${
  //               openOrderFilterRegularChats ? " active" : ""
  //             }`}
  //             onClick={(e) => {
  //               e.preventDefault();
  //               handleOpenOrderFilterRegularChat();
  //             }}
  //           >
  //             <Setting color="#455CC7" variant="outline" />
  //           </div>
  //         </LightTooltip>
  //       );
  //     default:
  //       return null;
  //   }
  // };
  const renderCorrectOrderFilter = () => {
    switch (tabSelected) {
      case "standByChatsTab":
        return (
          <OrderFilter
            filterOrderSelected={filterOrderStandbyChat}
            onSelectFilter={handleChangeOrderFilterStandbyChats}
          />
        );
      case "regularChatTab":
        return (
          <OrderFilter
            filterOrderSelected={filterOrderRegularChat}
            onSelectFilter={handleChangeOrderFilterRegularChats}
          />
        );
      default:
        return null;
    }
  };
  const renderCorrectTabsFilters = () => {
    switch (tabSelected) {
      case "standByChatsTab":
        return (
          <div className="side-queues__tabs-filters__tabs-settings-container">
            <ul className="side-queues__tabs-filters__tabs-settings-container__tabs">
              <li>
                <button
                  className={`${
                    tabFilterStandbyChatSelected === "allChats" ? "active" : ""
                  }`}
                  onClick={() => {
                    changeTabFilterStandbyChat("allChats");
                  }}
                >
                  Todas
                </button>
              </li>
              <li>
                <button
                  className={`${
                    tabFilterStandbyChatSelected === "unreadedChats"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    changeTabFilterStandbyChat("unreadedChats");
                  }}
                >{`Não lidas (${numberOfStandbyChatsWithUnreadedMessages})`}</button>
              </li>
            </ul>
          </div>
        );
      case "regularChatTab":
        return (
          <div className="side-queues__tabs-filters__tabs-settings-container">
            <ul className="side-queues__tabs-filters__tabs-settings-container__tabs">
              <li>
                <button
                  className={`${
                    tabFilterRegularChatSelected === "allChats" ? "active" : ""
                  }`}
                  onClick={() => {
                    changeTabFilterRegularChat("allChats");
                  }}
                >
                  Todas
                </button>
              </li>
              <li>
                <button
                  className={`${
                    tabFilterRegularChatSelected === "unreadedChats"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    changeTabFilterRegularChat("unreadedChats");
                  }}
                >{`Não lidas (${numberOfRegularChatsWithUnreadedMessages})`}</button>
              </li>
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  const renderCorrectQueue = () => {
    switch (tabSelected) {
      case "standByChatsTab":
        return (
          <ul className="side-queues__queue__list">
            <AutoSizer>
              {({ width, height }) => {
                const cellHeight = 80;
                const rowRendered = ({ key, index, style }) => {
                  const call = filteredSatndbyChats[index];

                  return (
                    <QueueItemMonitoring
                      key={key}
                      style={style}
                      call={call}
                      selectedCall={selectedChat || {}}
                      onEndCall={onEndCall}
                      onTransferCall={onTransferCall}
                      onAnnotationCall={onAnnotationCall}
                      onSearch={onSearchInCall}
                      search={textToFilterStandbyChats}
                      onSelectCall={onSelectCall}
                    />
                  );
                };
                return (
                  <List
                    width={width}
                    height={height}
                    rowCount={filteredSatndbyChats.length}
                    rowHeight={cellHeight}
                    rowRenderer={rowRendered}
                  />
                );
              }}
            </AutoSizer>
          </ul>
        );
      case "regularChatTab":
        return (
          <ul className="side-queues__queue__list">
            <AutoSizer>
              {({ width, height }) => {
                const cellHeight = 80;
                const rowRendered = ({ key, index, style }) => {
                  const call = filteredRegularChats[index];

                  return (
                    <QueueItemMonitoring
                      key={`${key}`}
                      style={style}
                      call={call}
                      selectedCall={selectedChat || {}}
                      onEndCall={onEndCall}
                      onTransferCall={onTransferCall}
                      onAnnotationCall={onAnnotationCall}
                      onSearch={onSearchInCall}
                      search={textToFilterRegularChats}
                      onSelectCall={onSelectCall}
                    />
                  );
                };
                return (
                  <List
                    width={width}
                    height={height}
                    rowCount={filteredRegularChats.length}
                    rowHeight={cellHeight}
                    rowRenderer={rowRendered}
                  />
                );
              }}
            </AutoSizer>
          </ul>
        );
      default:
        return null;
    }
  };

  return (
    <div className="side-queues">
      <ul className="side-queues__tabs">
        {tabs.map((tab, index) => {
          return (
            <li
              key={`${tab.id}--${index}`}
              className={`side-queues__tabs__tab ${
                tab.id === tabSelected ? "active" : ""
              }`}
              onClick={() => {
                handleChangeTab(tab);
              }}
            >
              <div className="side-queues__tabs__tab__icon-qtd-chat-container">
                {tab.icon}
                <span>{`(${tab.qtdChats})`}</span>
              </div>
              {Boolean(tab.qtdMessages) && (
                <span className="side-queues__tabs__tab__qtd-unreades-messages">
                  {tab.qtdMessages}
                </span>
              )}
            </li>
          );
        })}
      </ul>
      <div className="side-queues__search-container">
        <h2>Conversas</h2>
        <SearchInput onSearch={onSearch} />
      </div>
      <div className="side-queues__tabs-filters">
        {renderCorrectTabsFilters()}
        <div className="side-queues__tabs-filters__order-filter">
          {renderCorrectOrderFilter()}
        </div>
      </div>
      <div className="side-queues__queue">{renderCorrectQueue()}</div>
    </div>
  );
};

export default SideQueues;
